module.exports = __webpack_public_path__ + "img/banner.49994d3.png";